import { withSvgIcon } from './withSvgIcon';

export const NavBarEnterprise = withSvgIcon(
  <>
    <path
      d="M4 9C4 8.05719 4 7.58579 4.29289 7.29289C4.58579 7 5.05719 7 6 7H18C18.9428 7 19.4142 7 19.7071 7.29289C20 7.58579 20 8.05719 20 9V18C20 18.9428 20 19.4142 19.7071 19.7071C19.4142 20 18.9428 20 18 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M8 7V6C8 5.05719 8 4.58579 8.29289 4.29289C8.58579 4 9.05719 4 10 4H14C14.9428 4 15.4142 4 15.7071 4.29289C16 4.58579 16 5.05719 16 6V7"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M10 12H14" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
